import { trpc } from "#/lib/trpc/client"
import { useQuery, type UseQueryResult } from "@tanstack/react-query"

type IntakeFormData = Awaited<ReturnType<typeof trpc.telemedicine.getIntakeForm.query>>

export function useIntakeForm(appointmentId: string, enabled: boolean): UseQueryResult<IntakeFormData> {
  return useQuery({
    queryKey: ["telemedicine", "getIntakeForm", appointmentId],
    queryFn: () => trpc.telemedicine.getIntakeForm.query({ appointmentId }),
    enabled: enabled && Boolean(appointmentId),
    refetchOnWindowFocus: false,
    staleTime: Infinity
  })
}
